import {cloneDeep} from 'lodash';

const MINI_SCREENS_CONFIG = 'config';
const MINI_SCREENS_VIEWS = 'views';
export const MINI_SCREENS_VIEWS_DOCUMENT = 'document';

export class MiniScreensConfig {
  static initViews(rawViews) {
    let viewsMap = {};
    if (rawViews) {
      viewsMap = cloneDeep(rawViews);
    }
    return viewsMap;
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
    this.loaded = false;
    this.viewsMap = {};
    if (
      this.rawData &&
      this.rawData[MINI_SCREENS_CONFIG] &&
      this.rawData[MINI_SCREENS_CONFIG][MINI_SCREENS_VIEWS]
    ) {
      this.viewsMap = MiniScreensConfig.initViews(
        this.rawData[MINI_SCREENS_CONFIG][MINI_SCREENS_VIEWS]
      );
      this.loaded = true;
    }
  }

  clone() {
    return Object.assign(new MiniScreensConfig(cloneDeep(this.rawData)), this);
  }

  getViews() {
    return this.viewsMap;
  }

  getScreensByView(viewId = MINI_SCREENS_VIEWS_DOCUMENT) {
    return this.viewsMap[viewId];
  }

  isLoaded() {
    return this.loaded;
  }
}

export default {MiniScreensConfig};
